import axios from "axios";

const store = {
  state: {},

  getters: {},

  mutations: {},

  actions: {
    findClosingsAction(Context, payload) {
      return new Promise((resolve, reject) => {
        axios
          .post(`/closings/find`, payload)
          .then((res) => {
            resolve(res.data);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },

    findListMovementClosingsAction(Context, closingId) {
      return new Promise((resolve, reject) => {
        axios
          .post(`/closings/find-list-movements`, { closing_id: closingId })
          .then((res) => {
            resolve(res.data);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
  },
};

export default store;
